import React from 'react'
import styles from './Card.module.scss'

// Shared surface primitive. variant: 'outlined' (default) | 'flat' | 'elevated'
const Card = ({ children, variant = 'outlined', className = '', style, onClick }) => {
  const variantClass = variant === 'flat' ? styles.flat : variant === 'elevated' ? styles.elevated : ''
  return (
    <div className={[styles.card, variantClass, className].join(' ')} style={style} onClick={onClick}>
      {children}
    </div>
  )
}

export default Card
